interface UrgencyProps {
  onApplyClick: () => void;
}

export default function Urgency({ onApplyClick }: UrgencyProps) {
  const features = [
    {
      icon: 'ri-user-heart-line',
      text: 'persönliche Begleitung'
    },
    {
      icon: 'ri-book-open-line',
      text: 'intensives Onboarding'
    },
    {
      icon: 'ri-trophy-line',
      text: 'echte Erfolgsunterstützung'
    },
    {
      icon: 'ri-team-line',
      text: 'direkter Zugang zu erfahrenen Partnern'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-12 text-center">
            Wir nehmen nur eine begrenzte Anzahl neuer Partner auf
          </h2>

          <div className="bg-white border-4 border-red-500 p-10 rounded-2xl shadow-2xl mb-12">
            <p className="text-xl text-gray-800 mb-8 leading-relaxed">
              Um die Qualität der Einarbeitung zu sichern, arbeiten wir nur mit einer begrenzten Anzahl neuer Partner pro Monat.
            </p>

            <p className="text-xl font-bold text-gray-900 mb-6">
              Das bedeutet:
            </p>

            <div className="grid md:grid-cols-2 gap-4 mb-8">
              {features.map((feature, index) => (
                <div 
                  key={index}
                  className="flex items-center gap-3 bg-blue-50 p-4 rounded-xl"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-blue-600 rounded-full flex-shrink-0">
                    <i className={`${feature.icon} text-xl text-white`}></i>
                  </div>
                  <span className="text-gray-800 font-medium">{feature.text}</span>
                </div>
              ))}
            </div>

            <div className="bg-red-50 border-2 border-red-500 p-6 rounded-xl">
              <p className="text-xl font-bold text-red-600 mb-2 flex items-center gap-2">
                <span>👉</span>
                <span>Die aktuellen Plätze sind limitiert.</span>
              </p>
              <p className="text-lg text-gray-800">
                Wenn du Teil dieses Aufbaus werden möchtest, nutze jetzt die Chance.
              </p>
            </div>
          </div>

          <div className="text-center">
            <button 
              onClick={onApplyClick}
              className="inline-flex items-center gap-3 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white text-xl font-bold px-12 py-6 rounded-full transition-all duration-300 shadow-2xl hover:shadow-red-500/50 hover:scale-105 whitespace-nowrap cursor-pointer animate-pulse"
            >
              <span>👉</span>
              <span>Jetzt bewerben</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
